import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../svg";
import { YZCanvasContext } from "../canvas";

export class CrossShape extends Shape {
  constructor(options?: ShapeOptions) {
    super({
      ...options,
      initD: `m5.068 9.267-3.08-.77a.512.512 0 0 1 0-.994l3.08-.77a2.289 2.289 0 0 0 1.665-1.665l.77-3.08a.512.512 0 0 1 .994 0l.77 3.08c.205.82.845 1.46 1.665 1.665l3.08.77a.512.512 0 0 1 0 .994l-3.08.77a2.29 2.29 0 0 0-1.665 1.665l-.77 3.08a.512.512 0 0 1-.994 0l-.77-3.08a2.289 2.289 0 0 0-1.665-1.665Z`
    });
  }

  protected cloneShape(): CrossShape {
    const shape = new CrossShape({
      ...super.getBaseOptions()
    });
    return shape;
  }
}

export default CrossShape;
